import { connect } from 'react-redux';
import Entry from 'single_entry/containers/entry';

export function mapStateToProps() {
  return {
    drawerState: {
      leftDrawerVisible: true,
      entryCommentsVisible: true,
      entryRevisionsVisible: false,
    },
  };
}

export default connect(mapStateToProps)(Entry);



// WEBPACK FOOTER //
// ./single_entry/containers/comments.js